<template>
  <div>
    <div v-if="item">
      <div class="breadcrumb-area pos-relative w-100">
        <h1>Chi tiết yêu cầu hoàn hàng</h1>
        <div class="btn-group float-right">
          <button
            class="btn font-medium btn-outline-secondary"
            v-if="canApprove(item.status, item.managerIdInventory)"
            @click="approveItem(item)"
          >
            <i class="bx bx-check-circle"></i><span>&nbsp;</span>Duyệt
          </button>
          <button
            v-if="canReject(item.status, item.managerIdInventory)"
            class="btn font-medium btn-outline-secondary"
            @click="rejectItem(item)"
          >
            <i class="bx bx-x-circle"></i><span>&nbsp;</span>Từ chối
          </button>
          <!-- <button class="btn font-medium btn-outline-secondary" @click="inTicket(item.id)">
            <i class="bx bx-copy"></i><span>&nbsp;</span>In phiếu
          </button> -->
          <button
            class="btn font-medium btn-outline-secondary"
            v-if="canEdit(item.status, item.userCreator)"
            @click="editItem(item.id)"
          >
            <i class="bx bx-pencil"></i><span>&nbsp;</span>Sửa
          </button>
          <button
            v-if="canCancel(item.status, item.userCreator, item.managerIdInventory)"
            class="btn font-medium btn-outline-secondary"
            @click="cancelItem(item)"
          >
            <i class="bx bxs-trash"></i><span>&nbsp;</span>Huỷ
          </button>

          <button
            type="button"
            class="font-medium btn btn-outline-secondary"
            @click="$router.push('/return-request')"
          >
            <i class="bx bx-exit"></i> Quay lại
          </button>
        </div>
      </div>
      <div class="card p-10 pt-15 b-t-1-869fb229">
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-detail">
              <h1 class="form-inner-heading mb-1">Thông tin chung</h1>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Mã yêu cầu<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.billNumber }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Thời gian tạo<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.dateCreate | formatDate('DD/MM/YYYY, HH:mm') }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Thời gian hoàn<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.timeReturn | formatDate('DD/MM/YYYY, HH:mm') }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row" v-if="item.status === 'APPROVED'">
                <label for="" class="col-sm-4 col-form-label">
                  Thời gian duyệt/từ chối<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.timeApprove | formatDate('DD/MM/YYYY, HH:mm') }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row" v-if="item.status === 'REJECTED'">
                <label for="" class="col-sm-4 col-form-label">
                  Thời gian duyệt/từ chối<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.timeReject | formatDate('DD/MM/YYYY, HH:mm') }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Người tạo<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.userCreator && item.userCreator.name }}
                  </p>
                  <p class="form-control-plaintext f12 small text-muted">
                    {{ item.userCreator && item.userCreator.email }}
                  </p>
                </div>
              </div>

              <div
                class="form-group form-row"
                v-if="item.status === 'APPROVED' && item.personApprove"
              >
                <label for="" class="col-sm-4 col-form-label">
                  Người duyệt/từ chối<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.personApprove.name }}
                  </p>
                  <p class="form-control-plaintext f12 small text-muted">
                    {{ item.personApprove.email }}
                  </p>
                </div>
              </div>

              <div
                class="form-group form-row"
                v-if="item.status === 'REJECTED' && item.personReject"
              >
                <label for="" class="col-sm-4 col-form-label">
                  Người duyệt/từ chối<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.personReject.name }}
                  </p>
                  <p class="form-control-plaintext f12 small text-muted">
                    {{ item.personReject.email }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Trạng thái<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    <span class="badge" :class="[item.status || '']">
                      {{ item.status | transformData(Config.statusImportWarehouse) }}
                    </span>
                  </p>
                </div>
              </div>

              <div class="form-group form-row" v-if="item.reasonReturn">
                <label for="" class="col-sm-4 col-form-label">
                  Lý do hoàn<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.reasonReturn | transformData(Config.reasonReturn) }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Ghi chú<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.description || '' }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-detail">
              <h1 class="form-inner-heading mb-1">Lịch sử</h1>

              <div v-if="item.orderHistories && item.orderHistories.length > 0">
                <div class="table-responsive">
                  <table class="table table-bordered table-hover">
                    <thead class="thead-light">
                      <tr>
                        <th>Thời gian</th>
                        <th>Người thực hiện</th>
                        <th>Loại hành động</th>
                        <th>Lý do</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(history, index) in item.orderHistories" :key="`history${index}`">
                        <td class="f12">
                          {{ history.dateCreate | formatDate('HH:mm DD/MM/YYYY') }}
                        </td>
                        <td class="f12">
                          <div>{{ history.userApprove && history.userApprove.name }}</div>
                          <div class="small text-muted">
                            {{ history.userApprove && history.userApprove.email }}
                          </div>
                        </td>
                        <td class="f12">
                          <span class="badge" :class="[history.status || '']">
                            {{ history.status | transformData(Config.statusImportWarehouse) }}
                          </span>
                        </td>
                        <td class="f12">
                          {{ history.description }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-else class="text-center text-muted py-3">Chưa có lịch sử</div>
            </div>
          </div>
        </div>

        <div class="card pt-2 p-10 mt-3">
          <div class="d-flex pos-relative w-100 justify-content-between mb-2">
            <h1 class="form-inner-heading mb-0 pb-0">Danh sách thiết bị</h1>
          </div>
          <div class="box-header">
            Tổng số thiết bị:
            <strong class="text-primary">{{ item.devices ? item.devices.length : 0 }}</strong>
          </div>
          <div class="tab-content">
            <div class="table-responsive" style="overflow: auto; max-height: 70vh">
              <table class="table table-hover table-bordered">
                <thead class="thead-light">
                  <tr class="text-center">
                    <th style="width: 50px">STT</th>
                    <th>Tên thiết bị</th>
                    <th>Serial thiết bị</th>
                    <th>Mã HĐ/PL</th>
                    <th>Trạng thái thiết bị</th>
                    <th>Trạng thái gỡ</th>
                    <th>Ghi chú</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(device, index) in item.devices" :key="`device${index}`">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td>{{ device.categoryName || device.abbreviation }}</td>
                    <td>{{ device.serial }}</td>
                    <td>{{ device.contractCode }}</td>
                    <td class="text-center">
                      <span
                        v-if="device.status"
                        class="badge"
                        :class="getDeviceStatusClass(device.status)"
                      >
                        {{ getDeviceStatusText(device.status) }}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td class="text-center">
                      <span
                        v-if="device.statusSyncReturn"
                        class="badge"
                        :class="getShippingStatusClass(device.statusSyncReturn)"
                      >
                        {{ getShippingStatusText(device.statusSyncReturn) }}
                      </span>
                    </td>
                    <td>{{ device.noteImport || '' }}</td>
                  </tr>
                  <tr v-if="!item.devices || item.devices.length === 0">
                    <td colspan="7" class="text-center text-muted">Không có thiết bị nào</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-if="notiModal">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      @click="notiModal = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body text-center">
                    <img :src="iconNoti" alt="icon-successs" />
                    <h2 class="f18 py-3">{{ msgNoti }}</h2>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="checkToActionModal(keyCheck)"
                      data-dismiss="modal"
                      v-if="keyCheck === 'accept' || keyCheck === 'back' || keyCheck === 'addLead'"
                    >
                      Đồng ý
                    </button>
                    <button
                      type="button"
                      class="btn btn-light"
                      @click="notiModal = false"
                      data-dismiss="modal"
                      v-if="keyCheck === 'cancel' || keyCheck === 'back'"
                    >
                      Bỏ qua
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { DeviceService } from '@/services/device.service'
  import Config from '@/thirdParty/config'
  import mxItemAction from './mx-item-action.js'

  export default {
    mixins: [mxItemAction],
    data() {
      return {
        item: null,
        entryId: this.$route.params.entryId,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loading: false,
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        Config,
      }
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig?.find(e => e.id === data) ?? {}
        return dataReturn.text
      },
    },
    created() {
      this.fetchData()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    methods: {
      async fetchData() {
        try {
          this.loading = true
          const response = await DeviceService.detailReturnRequest(this.entryId)
          if (response.code === 1000 || response.success) {
            this.item = response.data
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      showErr(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
      },

      showSuccess(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-success2.svg')
        this.msgNoti = message
      },

      getPersonAction(status) {
        if (status === 'APPROVED') return 'duyệt'
        if (status === 'REJECTED') return 'từ chối'
        return 'huỷ'
      },

      getDeviceStatusClass(status) {
        const statusMap = {
          AVAILABILITY: 'badge-success',
          WAIT_IMPORT: 'badge-warning',
          WAIT_TRANSFER: 'badge-warning',
          MOVING: 'badge-info',
          WAITING_EXPORT: 'badge-warning',
          WARRANTY: 'badge-warning',
          CANCELLED: 'badge-secondary',
          LOSS: 'badge-danger',
          USED: 'badge-info',
          DONE: 'badge-success',
          EXPORTED: 'badge-success',
          LENT: 'badge-success',
          LENT_WARRANTY: 'badge-success',
          EXPORT_RENT: 'badge-success',
          WARRANTING: 'badge-warning',
          WAIT_USAGE_CHANGE: 'badge-warning',
          WAIT_RETURN: 'badge-warning',
          HANDOVER_WAREHOUSE: 'badge-success',
          TOO_HDD_NHAT: 'badge-danger',
          XUAT_THANH_CONG: 'badge-success',
          DANG_SU_DUNG: 'badge-warning',
        }
        return statusMap[status] || 'badge-secondary'
      },

      getDeviceStatusText(status) {
        const textMap = {
          AVAILABILITY: 'Khả dụng',
          WAIT_IMPORT: 'Chờ nhập',
          WAIT_TRANSFER: 'Chờ chuyển',
          MOVING: 'Đang chuyển',
          WAITING_EXPORT: 'Tạo HĐ, chờ duyệt',
          WARRANTY: 'Chờ bảo hành',
          CANCELLED: 'Đã hủy',
          LOSS: 'Thất lạc',
          USED: 'Đã qua sử dụng',
          DONE: 'Xuất thành công',
          EXPORTED: 'Xuất thành công',
          LENT: 'Xuất thành công',
          LENT_WARRANTY: 'Xuất thành công',
          EXPORT_RENT: 'Xuất thành công',
          WARRANTING: 'Đang bảo hành',
          WAIT_USAGE_CHANGE: 'Chờ thay đổi mục đích SD',
          WAIT_RETURN: 'Chờ hoàn',
          HANDOVER_WAREHOUSE: 'Tại kho hoàn',
          TOO_HDD_NHAT: 'Thất bại',
          XUAT_THANH_CONG: 'Xuất thành công',
          DANG_SU_DUNG: 'Đang sử dụng',
        }
        return textMap[status] || status
      },

      getShippingStatusClass(status) {
        const statusMap = {
          PROGRESS: 'badge-warning',
          SUCCESS: 'badge-success',
          FAILURE: 'badge-danger',
          FAILED: 'badge-danger',
        }
        return statusMap[status] || 'badge-secondary'
      },

      getShippingStatusText(status) {
        const textMap = {
          PROGRESS: 'Đang xử lý',
          SUCCESS: 'Thành công',
          FAILURE: 'Thất bại',
          FAILED: 'Thất bại',
          DANG_XU_LY: 'Đang xử lý',
          THANH_CONG: 'Xuất thành công',
          THAT_BAI: 'Thất bại',
        }
        return textMap[status] || status
      },
    },
  }
</script>

<style scoped>
  .history-item {
    background-color: #f8f9fa;
    border-radius: 4px;
  }

  .history-item:last-child {
    border-bottom: none !important;
  }

  .form-inner-heading {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }

  .badge {
    padding: 4px 8px;
    font-size: 11px;
    font-weight: 500;
  }

  .small {
    font-size: 12px;
  }
</style>
